/**
 * HPH FAQ
 * Accordion toggle + category pill navigation + sticky nav.
 * Vanilla JS, IIFE pattern. ~60 lines.
 * Created: June 10, 2026.
 */
(function () {
  'use strict';

  var section = document.querySelector('.hph-faq-section');
  if (!section) return;

  /* ---- Accordion toggle ---- */
  var questions = section.querySelectorAll('.hph-faq-item__question');

  questions.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!answer) return;

      /* Close siblings in same group */
      var group = btn.closest('.hph-faq-group');
      if (group) {
        group.querySelectorAll('.hph-faq-item__question[aria-expanded="true"]').forEach(function (open) {
          if (open !== btn) {
            open.setAttribute('aria-expanded', 'false');
            var sib = document.getElementById(open.getAttribute('aria-controls'));
            if (sib) sib.style.gridTemplateRows = '0fr';
          }
        });
      }

      /* Toggle clicked */
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      answer.style.gridTemplateRows = expanded ? '0fr' : '1fr';
    });
  });

  /* ---- Category pill nav ---- */
  /* ---- Category nav = native anchor jump (mirrors Services .hph-srv-nav) ----
     The chips are <a href="#faq-..."> and each group carries scroll-margin-top, so the
     browser scrolls and lands the group under the sticky nav from ANY start position.
     No JS scroll math (the old math mis-fired from the very top of the page: clicking
     Products stopped on Shipping & Delivery). This block only highlights the chip of the
     category currently in view (pure progressive enhancement; the jump works without it). */
  var nav = section.querySelector('.hph-faq-nav');
  if (nav && 'IntersectionObserver' in window) {
    var chips = Array.prototype.slice.call(nav.querySelectorAll('.hph-faq-nav__pill'));
    var map = {};
    chips.forEach(function (c) {
      var id = (c.getAttribute('href') || '').replace('#', '');
      if (id) map[id] = c;
    });
    var groups = Object.keys(map)
      .map(function (id) { return document.getElementById(id); })
      .filter(Boolean);
    if (groups.length) {
      /* Keep the ACTIVE pill visible: on mobile the track overflows horizontally, so when
         the scrollspy activates a pill that sits off-screen (e.g. Clinic, last category)
         the user saw no highlight at all (Dan, Aug 11). Horizontal scroll on the track
         ONLY - never scrollIntoView, which would also scroll the PAGE vertically to the
         nav mid-read. */
      var track = nav.querySelector('.hph-faq-nav__track');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var revealChip = function (chip) {
        if (!track || track.scrollWidth <= track.clientWidth) return;
        var target = chip.offsetLeft - (track.clientWidth - chip.offsetWidth) / 2;
        track.scrollTo({ left: target, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      };
      var setActive = function (id) {
        chips.forEach(function (c) { c.classList.remove('hph-faq-nav__pill--active'); });
        if (map[id]) {
          map[id].classList.add('hph-faq-nav__pill--active');
          revealChip(map[id]);
        }
      };
      var io = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (e) {
          if (e.isIntersecting && (!best || e.boundingClientRect.top < best.boundingClientRect.top)) best = e;
        });
        if (best && best.target.id) setActive(best.target.id);
      }, { rootMargin: '-195px 0px -55% 0px', threshold: 0 });
      groups.forEach(function (g) { io.observe(g); });
    }
  }
})();
